<script setup>
    import MainHeader from './../../components/HeaderComponent.vue';
    import registrationApplyArm from '@/components/modal/ConsultationWebRegistrationApplyArmComponent.vue';
    import registrationApplyTms from '@/components/modal/ConsultationWebRegistrationApplyTmsComponent.vue';
    import detailArm from '@/components/modal/ConsultationWebDetailArmComponent.vue';
    import detailTms from '@/components/modal/ConsultationWebDetailTmsComponent.vue';
    import { ref, onMounted, inject, getCurrentInstance } from 'vue';
    import { useConsultationWebStore } from '@/stores/consultation/consultationWebStore';
    import suerveyApply from '@/components/modal/SuerveyApplyComponent.vue';
    import { useLoginStore } from '@/stores/login/loginStore';
    import { useCommonStore } from '@/stores/common/commonStore';
    import { useLanguageStore } from '@/stores/common/languageStore';

    import { useRoute } from 'vue-router';

    import Pagination from '@/components/PaginationComponent.vue';

    // Utis
    import Utils from '@/commonProject/helpers/utils';

    const app = getCurrentInstance();
    const consultationWebStore = useConsultationWebStore();
    const loginStore = useLoginStore();
    const commonStore = useCommonStore();
    const languageStore = useLanguageStore();

    const consultationList = ref([]);
    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    const suerveyApplyComponent = ref();
    const suerveyApplyDispFlg = ref('');

    // ページングパーツ
    const currentPage = ref(1);
    const totalPages = ref(0);

    const route = useRoute();

    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    let keepWebCngPk = null;

    /**
     * 初期処理
     */
    onMounted(async () => {
        // Web相談一覧取得
        await getConsultationWebList();

        // 画面遷移元情報を取得
        const pageRouterParams = commonStore.from.split(':::::');

        // 画面遷移元情報を初期化する。
        commonStore.from = '';

        // 画面遷移元に応じて、本モーダルの画面表示を制御する。
        if (!Utils.isNullEmpty(route.query.cngCat)) {
            openRegistrationApplyTms();
        } else {
            // 別画面の遷移先を判定する。
            switch (pageRouterParams[0]) {
                case 'NewsDetail':
                    {
                        // ホーム画面のお知らせモーダルからの遷移。

                        if (!Utils.isNullEmpty(pageRouterParams[1])) {
                            // お知らせモーダルの「アンケートを回答」ボタンをクリックして取得したお知らせPKを保管する。
                            consultationWebStore.noticeHistPk = pageRouterParams[1];
                            keepWebCngPk = pageRouterParams[1];

                            // ログインしたベンダー種別に応じて、表示するアンケートモーダルを制御する。
                            switch (loginStore.getVendorType) {
                                case '1':
                                    // ARMモードの場合。

                                    // アンケートモーダルを開く過程で、詳細モーダルも表示しておく。
                                    openDetailArm(keepWebCngPk);

                                    // アンケートモーダルを表示する。
                                    openArmSuerveyApplyModal();

                                    // 詳細モーダルは閉じておく。
                                    // アンケートモーダルを閉じた時点で、詳細モーダルを開く。
                                    detailArmDispFlg.value = '';
                                    break;
                                case '2':
                                    // TMSモードの場合。

                                    // アンケートモーダルを開く過程で、詳細モーダルも表示しておく。
                                    openDetailTms(keepWebCngPk);

                                    // アンケートモーダルを表示する。
                                    openTmsSuerveyApplyModal();

                                    // 詳細モーダルは閉じておく。
                                    // アンケートモーダルを閉じた時点で、詳細モーダルを開く。
                                    detailTmsDispFlg.value = '';
                                    break;
                                default:
                                    // 何もしない。
                                    break;
                            }
                        } else {
                            // Web相談登録入力モーダルを「新しい相談」として表示
                            newConsultation();
                        }
                    }
                    break;
                case 'NewsDetail2':
                    {
                        // ホーム画面のお知らせモーダルからの遷移。
                        // Web相談の回答でお知らせPKを保持する。

                        if (!Utils.isNullEmpty(pageRouterParams[1])) {
                            // お知らせモーダルの「アンケートを回答」ボタンをクリックして取得したお知らせPKを保管する。
                            consultationWebStore.noticeHistPk = pageRouterParams[1];
                            keepWebCngPk = pageRouterParams[1];

                            // Web相談登録入力モーダルを「新しい相談」として表示
                            newConsultation();
                        } else {
                            // Web相談登録入力モーダルを「新しい相談」として表示
                            newConsultation();
                        }
                    }
                    break;
                default:
                    // 何もしない。
                    break;
            }
        }
    });

    /**
     * Web相談一覧取得処理
     */
    async function getConsultationWebList() {
        // Storeを初期化する。
        consultationWebStore.reset();

        const maxPage = 50;
        const requestBody = {
            Lang: languageStore.getLanguageValue,
            PageCond: {
                RowPosition: maxPage * (currentPage.value - 1) + 1,
                RowAmount: maxPage,
                RowCount: true,
            },
        };
        const response = await consultationWebStore.postWebLstAction(API_URL, requestBody);
        if (response.success) {
            consultationList.value = consultationWebStore.consultationList;
            totalPages.value = response.responseBody.PageInfo.RowResult;
            handleOnloadPagination(totalPages.value);
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }
    /**
     * 一覧からの表示モーダル分岐処理
     * @param consultationContents Web相談一覧選択行情報
     */
    async function selectModal(consultationContents) {
        // 種別がARM型の場合、Web相談登録入力(ARM型)
        if (loginStore.getVendorType === '1') {
            // 一時保存中の場合、Web相談登録画面を表示
            if (consultationContents.WebCngStatus === '1') {
                openRegistrationApplyArm(consultationContents.WebCngPk);
                // 相談中、相談終了の場合、Web相談詳細画面を表示
            } else if (consultationContents.WebCngStatus === '2' || consultationContents.WebCngStatus === '3') {
                openDetailArm(consultationContents.WebCngPk);
            }
            // 種別がTMS型の場合、Web相談登録入力(TMS型)
        } else if (loginStore.getVendorType === '2') {
            // 一時保存中の場合、Web相談登録画面を表示
            if (consultationContents.WebCngStatus === '1') {
                openRegistrationApplyTms(consultationContents.WebCngPk);
                // 相談中、相談終了の場合、Web相談詳細画面を表示
            } else if (consultationContents.WebCngStatus === '2' || consultationContents.WebCngStatus === '3') {
                openDetailTms(consultationContents.WebCngPk);
            }
        }
    }

    /**
     * Web相談登録入力モーダルを「新しい相談」として表示
     */
    async function newConsultation() {
        // ベンダーによって表示するモーダルをWeb相談登録入力(ARM型)、Web相談登録入力(TMS型) に分岐
        // 	VendorType ベンダー種別("1"：ARM型、"2"：TMS型)
        if (loginStore.getVendorType === '1') {
            openRegistrationApplyArm();
        } else {
            openRegistrationApplyTms();
        }
    }

    /**
     * ページ操作
     * @param newPage
     */
    function handlePageChange(newPage) {
        currentPage.value = newPage;

        // ページング実行により、Web相談一覧取得APIを再実行する。
        getConsultationWebList();
    }

    const pagination = ref();
    /**
     * ページングの初期処理を実行する。
     * 取得したAPIのデータ数を引き渡す。
     */
    function handleOnloadPagination(RowResult) {
        pagination.value.onload(RowResult);
    }

    /**
     * Web相談登録入力(ARM型)モーダル
     */
    const registrationApplyArmDispFlg = ref('');
    const registrationApplyArmComponent = ref();
    function openRegistrationApplyArm(WebCngPk) {
        // お知らせモーダルから、現況把握のWeb相談ボタンがクリックされた場合の、お知らせPKの一時退避用変数
        let noticeHistPk = null;

        // お知らせPK情報が退避できる場合は退避する。
        if (!Utils.isNullEmpty(consultationWebStore.noticeHistPk)) {
            noticeHistPk = consultationWebStore.noticeHistPk;
        }

        // Storeを初期化する。
        consultationWebStore.clearRegistrationFormData();

        // お知らせPK情報を復元する。
        if (!Utils.isNullEmpty(noticeHistPk)) {
            consultationWebStore.noticeHistPk = noticeHistPk;
        }

        registrationApplyArmComponent.value.setInfo(WebCngPk);
        registrationApplyArmDispFlg.value = 'block';
        document.body.classList.add('modal-open'); //スクロール停止
    }
    function closeRegistrationApplyArm() {
        registrationApplyArmDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
    }
    function closeUpdateRegistrationApplyArm() {
        registrationApplyArmDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        getConsultationWebList();
    }

    /**
     * Web相談登録入力(TMS型)モーダル
     */
    const registrationApplyTmsDispFlg = ref('');
    const registrationApplyTmsComponent = ref();
    function openRegistrationApplyTms(WebCngPk) {
        // お知らせモーダルから、現況把握のWeb相談ボタンがクリックされた場合の、お知らせPKの一時退避用変数
        let noticeHistPk = null;

        // お知らせPK情報が退避できる場合は退避する。
        if (!Utils.isNullEmpty(consultationWebStore.noticeHistPk)) {
            noticeHistPk = consultationWebStore.noticeHistPk;
        }

        consultationWebStore.clearRegistrationFormData();

        // お知らせPK情報を復元する。
        if (!Utils.isNullEmpty(noticeHistPk)) {
            consultationWebStore.noticeHistPk = noticeHistPk;
        }

        registrationApplyTmsComponent.value.setInfo(WebCngPk);
        registrationApplyTmsDispFlg.value = 'block';
        document.body.classList.add('modal-open'); //スクロール停止
    }
    function closeRegistrationApplyTms() {
        consultationWebStore.clearRegistrationFormData();
        registrationApplyTmsDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
    }
    function closeUpdateRegistrationApplyTms() {
        registrationApplyTmsDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        getConsultationWebList();
    }

    /**
     * Web相談詳細(ARM型)モーダル
     */
    const detailArmDispFlg = ref('');
    const detailArmComponent = ref();
    function openDetailArm(WebCngPk) {
        consultationWebStore.clearRegistrationFormData();
        detailArmComponent.value.setInfo(WebCngPk);
        keepWebCngPk = WebCngPk;
        detailArmDispFlg.value = 'block';
        document.body.classList.add('modal-open'); //スクロール停止
    }
    function closeDetailArm() {
        consultationWebStore.clearRegistrationFormData();
        detailArmDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
    }
    function closeUpdateDetailArm() {
        consultationWebStore.clearRegistrationFormData();
        detailArmDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        getConsultationWebList();
    }
    function openRegistrationConfirm() {}

    /**
     * Web相談詳細(TMS型)モーダル
     */
    const detailTmsDispFlg = ref('');
    const detailTmsComponent = ref();
    function openDetailTms(WebCngPk) {
        consultationWebStore.clearRegistrationFormData();
        detailTmsComponent.value.setInfo(WebCngPk);
        keepWebCngPk = WebCngPk;
        detailTmsDispFlg.value = 'block';
        document.body.classList.add('modal-open'); //スクロール停止
    }
    function closeDetailTms() {
        consultationWebStore.clearRegistrationFormData();
        detailTmsDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
    }
    function closeUpdateDetailTms() {
        consultationWebStore.clearRegistrationFormData();
        detailTmsDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        getConsultationWebList();
    }

    //Web相談詳細(ARM型)モーダルからアンケート回答入力モーダルを開く
    function openArmSuerveyApplyModal() {
        detailArmDispFlg.value = '';
        suerveyApplyDispFlg.value = 'block';
        suerveyApplyComponent.value.openModal(API_URL, languageStore.getLanguageValue, null, keepWebCngPk, null);
    }
    //Web相談詳細(TMS型)モーダルからアンケート回答入力モーダルを開く
    function openTmsSuerveyApplyModal() {
        detailTmsDispFlg.value = '';
        suerveyApplyDispFlg.value = 'block';
        suerveyApplyComponent.value.openModal(API_URL, languageStore.getLanguageValue, null, keepWebCngPk, null);
    }

    //Web相談詳細(ARM型またはTMS型)モーダルから開いたアンケート回答入力モーダルを閉じる
    function suerveyApplyClose() {
        suerveyApplyDispFlg.value = '';
        if (loginStore.getVendorType === '2') {
            consultationWebStore.clearRegistrationFormData();
            detailTmsComponent.value.reDisplay();
            detailTmsDispFlg.value = 'block';
        } else {
            consultationWebStore.clearRegistrationFormData();
            detailArmComponent.value.reDisplay();
            detailArmDispFlg.value = 'block';
        }
        document.body.classList.remove('modal-open'); //スクロール再開
    }
</script>

<template>
    <section id="main">
        <section id="overlay" :style="{ display: registrationApplyArmDispFlg }">
            <registrationApplyArm ref="registrationApplyArmComponent" @registrationApplyArmModal:cancel="closeRegistrationApplyArm" @registrationApplyArmModal:cancelUpdate="closeUpdateRegistrationApplyArm" @registrationApplyArmModal:regist="openRegistrationConfirm" />
        </section>
        <section id="overlay" :style="{ display: registrationApplyTmsDispFlg }">
            <registrationApplyTms ref="registrationApplyTmsComponent" @registrationApplyTmsModal:cancel="closeRegistrationApplyTms" @registrationApplyTmsModal:cancelUpdate="closeUpdateRegistrationApplyTms" @registrationApplyTmsModal:regist="openRegistrationConfirm" />
        </section>
        <section id="overlay" :style="{ display: detailArmDispFlg }">
            <detailArm ref="detailArmComponent" @detailArmModal:cancel="closeDetailArm" @detailArmModal:cancelUpdate="closeUpdateDetailArm" @detailArmModal:OpenSuerveyApply="openArmSuerveyApplyModal" @detailArmModal:regist="openRegistrationConfirm" />
        </section>
        <section id="overlay" :style="{ display: detailTmsDispFlg }">
            <detailTms ref="detailTmsComponent" @detailTmsModal:cancel="closeDetailTms" @detailTmsModal:cancelUpdate="closeUpdateDetailTms" @detailTmsModal:OpenSuerveyApply="openTmsSuerveyApplyModal" @detailTmsModal:regist="openRegistrationConfirm" />
        </section>
        <section id="overlay" :style="{ display: suerveyApplyDispFlg }">
            <!--アンケートモーダル関連-->
            <suerveyApply ref="suerveyApplyComponent" @suerveyApplyModal:close="suerveyApplyClose" @suerveyApplyModal:update="suerveyApplyClose" />
        </section>
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <h3 class="counseling">
                    <span>{{ $t('consultationWebList.parts.pageTitle1') }}</span>
                </h3>
                <section class="whiteBoxContents counseling">
                    <ul class="btnArea left">
                        <li>
                            <button type="button" class="btnPrimary width120" id="openPopup" @click="newConsultation">{{ $t('consultationWebList.parts.button1') }}</button>
                        </li>
                    </ul>
                    <section class="innerTable">
                        <table class="table counseling">
                            <thead>
                                <tr>
                                    <th />
                                    <th>
                                        <template v-if="loginStore.getVendorType === '1'">
                                            <!--件名-->
                                            <span>{{ $t('consultationWebList.parts.tableHeader1') }}</span>
                                        </template>
                                        <template v-else-if="loginStore.getVendorType === '2'">
                                            <!--種別-->
                                            <span>{{ $t('consultationWebList.parts.tableHeader2') }}</span>
                                        </template>
                                    </th>
                                    <th>
                                        <!--更新日時-->
                                        <span>{{ $t('consultationWebList.parts.tableHeader3') }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="consultation in consultationList" :key="consultation.index">
                                    <tr @click="selectModal(consultation)">
                                        <td>
                                            <template v-if="consultation.WebCngStatus === '1'">
                                                <!--一時保存中-->
                                                <span class="counselingTableStatus1">{{ $t('consultationWebList.parts.dl1') }}</span>
                                            </template>
                                            <template v-else-if="consultation.WebCngStatus === '2'">
                                                <!--相談中-->
                                                <span class="counselingTableStatus2">{{ $t('consultationWebList.parts.dl2') }}</span>
                                            </template>
                                            <template v-else-if="consultation.WebCngStatus === '3'">
                                                <!--相談終了-->
                                                <span class="counselingTableStatus3">{{ $t('consultationWebList.parts.dl3') }}</span>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="loginStore.getVendorType === '1'">
                                                <span>{{ consultation.WebCngArmSubj }}</span>
                                            </template>
                                            <template v-else-if="loginStore.getVendorType === '2'">
                                                <span>{{ consultation.WebCngTmsCat1Nm }}</span>
                                            </template>
                                        </td>
                                        <td>
                                            <span>{{ consultation.WebCngUpdDt }}</span>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </section>
                    <Pagination ref="pagination" :currentPage="currentPage" :totalPages="totalPages" @pageChanged="handlePageChange" />
                </section>
                <section class="whiteBoxFooter" />
            </div>
        </div>
    </section>
</template>

<style></style>
